import React, {useContext, useRef, useEffect, forwardRef} from 'react';
import {Popup} from 'components';
import {includes, getElementAttributes, useWindowSize} from 'helpers';
import css from './scrollable.module.scss';

export const Scrollable = forwardRef(({ className, children, deps = [], ...props }, ref) => {
  const popup = useContext(Popup.Context);
  ref = ref ?? useRef();

  if (className == 'in-modal' && !popup) {
    return children;
  }

  useEffect(() => {
    requestAnimationFrame(() => {
      if (ref.current) {
        let { top, height } = ref.current.getBoundingClientRect();
        const selected = ref.current.querySelector('[aria-pressed="true"], [aria-current]');
        const isSidebar = ref.current.parentNode.tagName == 'ASIDE';
        if (includes(className, 'stretch-to-bottom')) {
          const indent = isSidebar ? 24 : 8;
          height = window.innerHeight - top - indent;
          ref.current.style.height = height + 'px';
        }
        if (selected) {
          ref.current.scroll(0, selected.getBoundingClientRect().top - top - height/2);
        }
      }
    });
  }, [useWindowSize(), ...deps]);

  return (
    <div className={css('scrollable', className)} ref={ref} {...getElementAttributes(props)} role="feed">
      { children }
    </div>
  );
});

Scrollable.Header = function Header({ className, ...props }) {
  return (
    <header {...props} className={css('header', className)} />
  );
}
